import { useDispatch, useSelector } from "react-redux";
import { setSelectedProductGroup } from "../redux/store/genericReportingSlice";
import { Select } from "antd";
import { useGetProductGroupsInConfigQuery } from "../redux/api/productGrouping";
import { useEffect } from "react";
import { Spin } from "antd";


const ProductGroupDropdown = ({ platform }) => {

    const dispatch = useDispatch();

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedConfig = useSelector((state) => state.genericReporting.selectedConfig);
    const selectedProductGroup = useSelector((state) => state.genericReporting.selectedProductGroup);

    const { data, isFetching } = useGetProductGroupsInConfigQuery({ client: selectedClient, configName: selectedConfig, platform: platform });

    // useffect to set the selected product group to the first product group in the list
    useEffect(() => {
        if (data && data.length > 0) {
            dispatch(setSelectedProductGroup(data[0]));
        }
    }, [data, dispatch]);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
        }}>
            <h4>Product Group</h4>
            {
                isFetching ? <Spin /> : (
                    <Select
                        value={selectedProductGroup}
                        style={{ width: '10vw', marginLeft: '0.5vw', marginRight: '0.5vw' }}
                        onChange={(value) => {
                            dispatch(setSelectedProductGroup(value));
                        }}
                    >
                        {
                            Array.isArray(data) && data.map((option) => {
                                return <Select.Option key={option} value={option}>{option}</Select.Option>
                            })
                        }
                    </Select>
                )
            }
        </div>
    );
};

export default ProductGroupDropdown;